// Reduce number of possible avatar sizes to leverage caching and reduce number
// of avatars we generate.
export type AvatarSize = 40 | 80 | 160 | 400;

// Only attempt resizing on known cloudflare origins, otherwise assets will 404.
const CLOUDFLARE_ORIGINS = [
  'https://uploads.servicebell.com',
  'https://uploads-staging.servicebell.com',
];

export function makeAvatarUrl(avatar: string, size: AvatarSize) {
  if (!size) {
    return avatar;
  }
  return makeResizerUrl(avatar, { width: size, height: size });
}

export function makeResizerUrl(
  ogUrl: string,
  options: { width: number; height: number },
) {
  try {
    const url = new URL(ogUrl);
    if (!CLOUDFLARE_ORIGINS.includes(url.origin)) {
      return ogUrl;
    }
    // Handle high dpi displays, but don't pick a number larger than the source of the avatar.
    const ratio = Math.max(Math.round(window.devicePixelRatio), 1);
    const w = options.width * ratio;
    const h = options.height * ratio;
    return `${url.origin}/cdn-cgi/image/width=${w},height=${h},f=auto${url.pathname}${url.search}`;
  } catch (err) {
    return ogUrl;
  }
}
